/* ============================================================
   PuroPaw Urinary Care PDP
   Vanilla JS, no dependencies.

   Selection model: the course picker resolves the variant. With a
   2-option product (legacy) rows carry size + duration and both picks
   matter; with a 1-option product rows have size:null and the size
   step is a dose finder only (one 120-tablet bottle per course).
   Shopify holds price = subscribe, compare_at_price = one-time, so the
   purchase toggle simply swaps which of the two we display.
   All money values are in pence.
   ============================================================ */
(function () {
  'use strict';

  function money(pence, format) {
    if (pence === null || pence === undefined || isNaN(pence)) return '';
    var value = (pence / 100).toFixed(2);
    // Keep it simple and predictable: the shop is GBP only.
    if (format && format.indexOf('£') === -1 && format.indexOf('{{') === -1) return value;
    return '£' + value;
  }

  function initSection(root) {
    var dataEl = root.querySelector('[data-ucp-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var rows = (data.hasVariants && data.variants.length) ? data.variants : (data.demo || []);
    if (!rows.length) return;

    var format = data.moneyFormat || '';
    var sizeInputs = Array.prototype.slice.call(root.querySelectorAll('[name^="ucp-size-"]'));
    var durInputs = Array.prototype.slice.call(root.querySelectorAll('[name^="ucp-duration-"]'));
    var buyInputs = Array.prototype.slice.call(root.querySelectorAll('[name^="ucp-purchase-"]'));
    var variantInput = root.querySelector('[data-ucp-variant-id]');
    var planInput = root.querySelector('[data-ucp-selling-plan]');
    var addBtn = root.querySelector('[data-ucp-add]');
    var addPrice = root.querySelector('[data-ucp-add-price]');
    var addLabel = root.querySelector('[data-ucp-add-label]');
    var supplyEl = root.querySelector('[data-ucp-supply]');
    var subPriceEl = root.querySelector('[data-ucp-sub-price]');
    var otPriceEl = root.querySelector('[data-ucp-ot-price]');
    var errEl = root.querySelector('[data-ucp-error]');
    var freqEl = root.querySelector('[data-ucp-frequency]');

    function selectedValue(inputs) {
      for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return inputs[i].value;
      return inputs.length ? inputs[0].value : null;
    }
    function selectedInput(inputs) {
      for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return inputs[i];
      return inputs[0] || null;
    }

    function findRow(size, duration) {
      for (var i = 0; i < rows.length; i++) {
        var rowSize = rows[i].size;
        if ((rowSize === null || rowSize === undefined || rowSize === size) && rows[i].duration === duration) return rows[i];
      }
      return null;
    }

    // Mark the chosen card in each group
    function paint(inputs, selectedClass) {
      inputs.forEach(function (input) {
        var card = input.closest('label');
        if (card) card.classList.toggle(selectedClass, input.checked);
      });
    }

    function update() {
      var size = selectedValue(sizeInputs);
      var duration = selectedValue(durInputs);
      var mode = selectedValue(buyInputs) || 'subscribe';
      var row = findRow(size, duration);

      paint(sizeInputs, 'is-selected');
      paint(durInputs, 'is-selected');
      paint(buyInputs, 'is-selected');

      // Each duration card shows the price for the currently selected size
      durInputs.forEach(function (input) {
        var card = input.closest('label');
        if (!card) return;
        var r = findRow(size, input.value);
        var p = card.querySelector('[data-ucp-duration-price]');
        var w = card.querySelector('[data-ucp-duration-was]');
        if (p) p.textContent = r ? money(mode === 'subscribe' ? r.sub : r.ot, format) : '';
        if (w) w.textContent = (r && mode === 'subscribe' && r.ot > r.sub) ? money(r.ot, format) : '';
      });

      if (subPriceEl) subPriceEl.textContent = row ? money(row.sub, format) : '';
      if (otPriceEl) otPriceEl.textContent = row ? money(row.ot, format) : '';

      var shown = row ? (mode === 'subscribe' ? row.sub : row.ot) : null;
      if (addPrice) addPrice.textContent = shown !== null ? '  ' + money(shown, format) : '';

      // Bottle maths: 120 tablets a bottle, tablets/day from the size step
      var tabs = parseInt((selectedInput(sizeInputs) || {}).dataset ? selectedInput(sizeInputs).dataset.tablets : 1, 10) || 1;
      var bottles = parseInt((selectedInput(durInputs) || {}).dataset ? selectedInput(durInputs).dataset.months : 1, 10) || 1;
      var days = Math.floor((bottles * 120) / tabs);
      if (supplyEl) {
        supplyEl.innerHTML =
          '<strong>' + bottles + '</strong> bottle' + (bottles === 1 ? '' : 's') + ' · 120 tablets each · ' +
          '<strong>' + tabs + '</strong> tablets a day lasts your dog about <strong>' + days + '</strong> days';
      }

      var available = row ? (row.available !== false) : false;
      if (variantInput) variantInput.value = row && row.id ? row.id : '';
      if (addBtn) {
        addBtn.disabled = !row || !available || !row.id;
        if (addLabel) addLabel.textContent = (row && !available) ? 'Sold out' : (addBtn.dataset.label || addLabel.textContent);
      }

      // Subscriptions only apply on the subscribe option
      if (planInput) planInput.disabled = (mode !== 'subscribe') || !planInput.value;

      var sticky = document.querySelector('[data-ucp-sticky-price]');
      if (sticky) sticky.textContent = shown !== null ? money(shown, format) : '';

      if (errEl) errEl.hidden = true;
    }

    sizeInputs.concat(durInputs, buyInputs).forEach(function (input) {
      input.addEventListener('change', update);
    });
    if (freqEl) freqEl.addEventListener('change', update);

    // ---- Gallery ----
    var mainImg = root.querySelector('[data-ucp-main-image]');
    root.querySelectorAll('[data-ucp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = btn.dataset.full;
        mainImg.removeAttribute('srcset');
        mainImg.alt = btn.dataset.alt || '';
        root.querySelectorAll('[data-ucp-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    // ---- Add to cart (AJAX) ----
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!variantInput || !variantInput.value) return; // let Shopify handle/validate
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        if (errEl) errEl.hidden = true;

        var body = { items: [{ id: Number(variantInput.value), quantity: 1 }] };
        if (planInput && !planInput.disabled && planInput.value) {
          body.items[0].selling_plan = Number(planInput.value);
        }

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
            document.dispatchEvent(new CustomEvent('ucp:added', { detail: res.json }));
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
          })
          .finally(function () { if (addBtn) addBtn.disabled = false; });
      });
    }

    // ---- Sticky bar: only once the buy box has scrolled past ----
    var sticky = document.querySelector('[data-ucp-sticky]');
    var stickyAdd = document.querySelector('[data-ucp-sticky-add]');
    if (sticky && addBtn) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
        });
      }, { threshold: 0 }).observe(addBtn);
      if (stickyAdd) stickyAdd.addEventListener('click', function () { addBtn.click(); });
    }

    update();
  }

  function boot() {
    document.querySelectorAll('[data-ucp-root]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-ucp-root]') : null;
    if (root) initSection(root);
  });
})();
